module.exports = __webpack_public_path__ + "img/whatsapp_check.d2472baf.png";